import ScrollSpy from "react-scrollspy-navigation";
import ProjectsListModal from "./Modals/ProjectsListModal";
import { useState } from "react";
import { createPortal } from "react-dom";

export default function YearSelect2({ projects }) {
    const [ showProjInspect, setShowProjInspect ] = useState(false);
    // <a href="#2024" className="yearopt">2024</a>
    let years = [];
    let cur;
    projects.forEach(project => {
        if (cur===project.Year) return;
        years.push(project.Year.toString());
        cur = project.Year;
    });
    
    return (
        <>
            <div className="yearselect">
                <div className="yearselect-content">
                    <div className="yearselect-content-wrapper">
                        <div style={{height:"1.9rem"}}>
                            <ScrollSpy className="yearselect" id="yearselect" activeClass="yearopt2-selected">
                                {years.map(year=>(
                                    <a key={year} href={"#"+year} className="yearopt2">{year}</a>
                                ))}
                            </ScrollSpy>
                        </div>
                        <span href="#." className="yearopt2 yearopt2-selected" style={{opacity:0, height:0, zIndex:-1, cursor:"default", userSelect:"none"}}>0000</span>
                    </div>
                    <button className="inspect-projects" onClick={()=>{setShowProjInspect(true)}}>&#9776;</button>
                </div>
            </div>
            {createPortal(<ProjectsListModal className={showProjInspect?" inspect-projects-modal-visible":""} projects={projects} callback={()=>setShowProjInspect(false)} />, document.body)}
        </>
    )
}